import { render, staticRenderFns } from "./QuotaCreate.vue?vue&type=template&id=5e48a75a&scoped=true&"
import script from "./QuotaCreate.vue?vue&type=script&lang=js&"
export * from "./QuotaCreate.vue?vue&type=script&lang=js&"
import style0 from "./QuotaCreate.vue?vue&type=style&index=0&id=5e48a75a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e48a75a",
  null
  
)

export default component.exports